import { render, staticRenderFns } from "./ShopStoreCategory.vue?vue&type=template&id=03e0ab45&scoped=true&"
import script from "./ShopStoreCategory.vue?vue&type=script&lang=js&"
export * from "./ShopStoreCategory.vue?vue&type=script&lang=js&"
import style0 from "./ShopStoreCategory.vue?vue&type=style&index=0&id=03e0ab45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e0ab45",
  null
  
)

export default component.exports